var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H24V24H0V0Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.83974 21.2864L6.263 18.7133L18.278 6.68359L20.8726 9.27531L8.83974 21.2864ZM2.26124 16.6543L7.35609 21.7428L1.56915 22.4332L2.26124 16.6543ZM2.71747 15.1723L14.7511 3.16113L17.3085 5.71501L5.29278 17.744L2.71747 15.1723ZM22.6286 5.71366C22.6286 6.64253 22.3347 7.52429 21.7978 8.26111L15.727 2.19878C16.4648 1.66258 17.3471 1.36914 18.278 1.36914C20.6767 1.36914 22.6286 3.31828 22.6286 5.71366ZM24.0005 5.71391C24.0005 2.56316 21.4331 0 18.2779 0C16.7493 0 15.3115 0.594024 14.2312 1.67355L14.2655 1.70853L1.09515 14.8556L-0.000183105 24.0001L9.15711 22.9078L22.813 9.2752L22.7772 9.23879C23.5673 8.23709 24.0005 7.00977 24.0005 5.71391Z",
  fill: "#009A96"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.92c392b0d57da75d9dfb946ef448d590.svg";